export default {
  'profilecredit.profilecreditreport': 'Оборот по кредитным счетам',
  'profilecredit.creditstatus': 'Кредитный статус',
  'profilecredit.credittotalamount': 'Общая сумма выделенного кредита',
  'profilecredit.creditremainamount': 'Общая сумма оставшегося кредита',
  'profilecredit.profilecreditreport': 'Назначенный кредитный отчет',
  'profilecredit.creditamount': 'Сумма кредита',
  'profilecredit.remaincreditamount': 'Оставшаяся сумма кредита',
  'profilecredit.assigndate': 'Назначенная дата',
  'profilecredit.duration': 'Продолжительность (день)',
  'profilecredit.active': 'активный',
  'profilecredit.expired': 'истекший',
  'profilecredit.sum': 'сумма',
  'profilecredit.expensesamount': 'ُИзрасходованная сумма кредита',
  'profilecredit.nocredit': 'Нет кредита',
  'profilecredit.assigncredit': 'Назначить кредит',
  'profilecredit.creditamountceiling': 'Максимальная сумма кредита',
  'profilecredit.deletecredit': 'Удалить кредит',
  'profilecredit.deleteconfirmation':
    'Вы действительно хотите удалить этот кредит?',
  'profilecredit.fullname': 'ФИО',
  'profilecredit.expensesreport': 'Отчет о расходах',
  'profilecredit.credit': 'кредит',
  'profilecredit.mycreditmanagement': 'Управление моими кредитами',
  'profilecredit.creditmanagement': 'Управление кредитования',
  'profilecredit.employeecreditmanagement': 'Управление кредитами сотрудников',
  'profilecredit.creditadd': 'Кредит успешно добавлен',
  'profilecredit.creditadderror':
    'Для этого профиля уже есть активное выделение',
  'profilecredit.noteligibleprofile':
    'Этот профиль не подходит для распределения',
  'profilecredit.downloadexcel': 'Скачать файл Excel',
  'profilecredit.fromdate': 'С назначенной даты',
  'profilecredit.todate': 'К назначенной дате',
};
